import { createSlice } from "@reduxjs/toolkit";
import dateFormat from "dateformat";
import {
  createFailed,
  deleteFailed,
  onErrorCreate,
  onErrorDelete,
  onErrorUpdate,
  onSetError,
  onSetLoaded,
  onSetLoadedCreate,
  onSetLoadedDelete,
  onSetLoadedUpdate,
  updateFailed,
} from "./../utils/loadedError";
import { convertTimezoneFromUTC } from "../../services/timezone";

const deleteRecords = (initialState, data) => {
  switch (data.action) {
    case "restore":
      return initialState.deletedData.filter((item) => item !== data.record);
    case "delete":
      return [...initialState.deletedData, data.record];
    default:
      return initialState.deletedData;
  }
};

function* idMaker() {
  var index = -1;
  while (true) yield index--;
}

let it = idMaker();

const initialactivewellboresState = {
  data: [],
  changedData: [],
  newData: [],
  Error: null,
  isLoaded: false,
  isLoadedCreate: true,
  isLoadedUpdate: true,
  isLoadedDelete: true,
  errorCreate: null,
  errorUpdate: null,
  errorDelete: null,
  //для кнопки отмена изменений или чтобы не прыгали редактируемые записи в сортировки
  changedRecords: {},
};

const activewellboresSlice = createSlice({
  name: "activewellbores",
  initialState: initialactivewellboresState,
  reducers: {
    onClearStore(state) {
      state.data = [];
      state.changedData = [];
      state.deletedData = [];
      state.newData = [];
      state.isLoaded = false;
      state.Error = null;
      state.isLoadedCreate = true;
      state.isLoadedDelete = true;
      state.isLoadedUpdate = true;
      state.errorCreate = null;
      state.errorDelete = null;
      state.errorUpdate = null;
      state.changedRecords = {};
    },

    onInitialActiveWellbores(state, action) {
      state.data = action.payload.map((item) => {
        return {
          ...item,
          start: item.start ? dateFormat(item.start, "yyyy-mm-dd") : item.start,
          finish: item.finish ? dateFormat(item.finish, "yyyy-mm-dd") : item.finish,
          time_zone: convertTimezoneFromUTC(item.time_zone),
        };
      });
      state.changedData = action.payload.map((item) => {
        return {
          ...item,
          start: item.start ? dateFormat(item.start, "yyyy-mm-dd") : item.start,
          finish: item.finish ? dateFormat(item.finish, "yyyy-mm-dd") : item.finish,
          time_zone: convertTimezoneFromUTC(item.time_zone),
        };
      });
      state.deletedData = [];
      state.newData = [];
      state.isLoaded = true;
      state.Error = null;
      state.isLoadedCreate = true;
      state.isLoadedDelete = true;
      state.isLoadedUpdate = true;
      state.errorCreate = null;
      state.errorDelete = null;
      state.errorUpdate = null;
    },

    onSetLoaded,
    onSetError,
    onSetLoadedCreate,
    onSetLoadedUpdate,
    onSetLoadedDelete,
    onErrorCreate,
    onErrorUpdate,
    onErrorDelete,
    createFailed,
    updateFailed,
    deleteFailed,

    deleteDataSuccess(state, action) {
      state.data = state.data.filter((item) => item.id !== action.payload);
      state.changedData = state.changedData.filter((item) => item.id !== action.payload);
      state.deletedData = state.deletedData.filter((item) => item !== action.payload);
      state.changedRecords = {};
      // state.isLoadedDelete = true;
    },

    updateDataSuccess(state, action) {
      const updatedItem = {
        ...action.payload,
        time_zone: convertTimezoneFromUTC(action.payload.time_zone),
      };
      state.data = state.data.map((item) => (item.id === updatedItem.id ? updatedItem : item));
      state.changedData = state.changedData.map((item) => (item.id === updatedItem.id ? updatedItem : item));
      state.changedRecords = {};
    },

    createDataSuccess(state, action) {
      const createdItem = {
        ...action.payload.data,
        time_zone: convertTimezoneFromUTC(action.payload.data.time_zone),
      };
      state.data = [...state.data, createdItem];
      state.changedData = [...state.changedData, createdItem];
      state.newData = state.newData.filter((item) => item.id !== action.payload.oldId);
      state.changedRecords = {};
    },

    changeData(state, action) {
      const { record, property, store } = action.payload;
      state[store] = state[store].map((item) => (item.id === record.id ? { ...item, [property]: record[property] } : item));

      const initialRecord = state.data.find((item) => item.id === record.id);
      const currentRecord = state[store].find((item) => item.id === record.id);
      if (!state.changedRecords[record.id]) {
        state.changedRecords[record.id] = {};
      }
      if (currentRecord[property] === initialRecord[property]) {
        delete state.changedRecords[record.id][property];
        if (Object.keys(state.changedRecords[record.id]).length === 0) {
          delete state.changedRecords[record.id];
        }
      } else {
        state.changedRecords[record.id][property] = currentRecord[property];
      }
    },

    deleteData(state, action) {
      const Id = action.payload.record;
      const store = action.payload.store;
      if (store === "changedData") {
        state.deletedData = [...deleteRecords(state, action.payload)];
      } else {
        state.newData = state.newData.filter((item) => item.id !== Id);
      }
    },

    createData(state, action) {
      let newRecord = {
        id: it.next().value,
        portal: null,
        customer: null,
        wellbore_id: null,
        wellbore: "",
        cluster: "",
        start: null,
        finish: null,
        date_moving: null,
        with_video: false,
        with_witsml: false,
        area: "",
        // comp_ip: '3445.3434.3432',
        // old_cluster: '',
        contacts: "",
        // status_comp: 'В работе',
        comment: "",
        time_zone: 0,
      };
      state.newData = [...state.newData, newRecord];
    },
  },
});

export const activewellboresActions = activewellboresSlice.actions;
export default activewellboresSlice.reducer;
